module.exports = __webpack_public_path__ + "static/media/checkbox-arrow-document.4d595d4a.svg";